import React from "react";
import girl from "../../img/herpimg.PNG";


const Header = () => {
  return (
    <>
    <div className="header" id='header'>
      <header>
        <section className="container h-main-hero-container">
          <div className="row">
            <div className="col-12 col-lg-6 header-left-side d-flex justify-content-center flex-column align-items-start ">
              <h1 className="display-2">
                25K+ Students <br /> Trust Us.
              </h1>
              <p className="main-hero-para">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et,
                quia quis? Ipsa officia ad deserunt voluptate quam, nisi odio
                officiis tempora recusandae voluptate quam, nisi odio officiis
                tempora recusandae
              </p>
              <h3>Get early access for you</h3>
              <div className="input-group mt-3">
                <input
                  type="text"
                  className="rounded-pill w-50  w-lg-75 me-3 p-2 form-control-text"
                  placeholder="Enter Your Email"
                />
                <a href="#" 
                    className="btn btn-outline-primary">Join us</a>
              
              </div>
            </div>
            {/*  --------------- main header right side--------------  */}
            <div className="col-12 col-lg-6 header-right-side d-flex justify-content-center align-items-center main-herosection-images">
              <img
                src={girl}
                alt="heroimg"
                className="img-fluid"
              />
            
            </div>
          </div>
        </section>
      </header>
      </div>
    </>
  );
};

export default Header;
